import { Field, SalesforceFieldType } from 'ts-force';

export const defaultSFFieldValues: Field = {
  aggregatable: true,
  autoNumber: false,
  byteLength: 0,
  calculated: false,
  cascadeDelete: false,
  caseSensitive: false,
  compoundFieldName: '',
  createable: true,
  custom: false,
  defaultValue: undefined,
  defaultValueFormula: undefined,
  defaultedOnCreate: false,
  dependentPicklist: false,
  deprecatedAndHidden: false,
  digits: 0,
  displayLocationInDecimal: false,
  encrypted: false,
  externalId: false,
  extraTypeInfo: '',
  filteredLookupInfo: {},
  groupable: true,
  highScaleNumber: false,
  htmlFormatted: false,
  idLookup: false,
  label: 'Field2',
  length: 0,
  mask: undefined,
  maskType: undefined,
  name: 'Field2',
  nameField: false,
  namePointing: false,
  nillable: false,
  permissionable: false,
  picklistValues: [],
  precision: 0,
  queryByDistance: false,
  referenceTargetField: {},
  referenceTo: [],
  relationshipName: '',
  relationshipOrder: 0,
  restrictedDelete: false,
  restrictedPicklist: false,
  scale: 0,
  soapType: '',
  sortable: false,
  type: SalesforceFieldType.STRING,
  unique: false,
  filterable: false,
  updateable: false,
  writeRequiresMasterRead: false,
  searchPrefilterable: false,
  polymorphicForeignKey: false,
};
